import { useState, useEffect, useRef } from 'react';
import React from 'react';
import { Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import EmbeddedVideoListing from '../../../../constants/CasestudyVideoListing';
import { useParams } from 'react';

import * as styles from './Diy.module.css';

const ActionButton = ({ formData, handleInputChange }) => {
  return (
    <>
      <Form.Group
        className={styles.persona}
        controlId="ActionButtonlabel"
        key="ActionButtonlabel"
      >
        <Form.Control
          name="ActionButtonlabel"
          type="text"
          className={styles?.name}
          placeholder="CTA Label"
          value={formData?.ActionButtonlabel}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
    </>
  );
};

export default ActionButton;
